var exports = {
  "I": "xe533113f--a9f00c--distance",
  "L": "xe533113f--a9f00c--categories",
};

module.exports = exports;
